import React, { useState, useEffect } from "react";
import { useMutation } from "react-query";
import UserService from "../../../services/userService";
import PhoneNumberSection from "./PhoneNumberSection";
import { useTranslation } from "react-i18next";
import { UiH4 } from "../../../components/text/UiTitle";

interface BillingAddressProps {
  billingAdress?: BillingAddressDTO;
}

const BillingAddress: React.FC<BillingAddressProps> = ({ billingAdress }) => {
  // Mutation for updating user information
  const [localUserInfo, setLocalUserInfo] = useState<
    BillingAddressDTO | undefined
  >(billingAdress);
  const [validationErrors, setValidationErrors] = useState({
    firstName: "",
    lastName: "",
    koreanFirstName: "",
    koreanLastName: "",
    phoneNumber: "",
    email: "",
    address: "",
  });
  const { t } = useTranslation();
  useEffect(() => {
    setLocalUserInfo(billingAdress);
  }, [billingAdress]);

  const mutation = useMutation(
    async (data?: BillingAddressDTO) => {
      if (!data) throw new Error("User info is not available");
      return await UserService.updateBillingAddress(data);
    },
    {
      onSuccess: (data) => {
        console.log("Update successful:", data);
      },
      onError: (error: any) => {
        console.error("Error updating user info:", error);
      },
    },
  );

  const handleUpdate = () => {
    if (localUserInfo && validateForm()) {
      mutation.mutate(localUserInfo);
    }
  };

  const validateForm = () => {
    if (!localUserInfo) return false;

    let errors: any = {};
    if (!localUserInfo.firstName) {
      errors.firstName = t("English first name is required");
    }
    if (!localUserInfo.lastName) {
      errors.lastName = t("English last name is required");
    }
    if (!localUserInfo.email) {
      errors.email = t("Email name is required");
    }
    if (localUserInfo.email && !localUserInfo.email.includes("@")) {
      errors.email = t("Email name incorrect format");
    }
    if (!localUserInfo.callingCode || !localUserInfo.phoneNumber) {
      errors.phoneNumber = t("Phone number is required");
    }
    // if (!localUserInfo.address) {
    //   errors.address = t("Address to is required");
    // }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const createBillingAddressUpdate = (
    fieldName: keyof BillingAddressDTO,
    value: string,
  ): Partial<BillingAddressDTO> => {
    return {
      [fieldName]: value,
    };
  };
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    fieldName: keyof BillingAddressDTO,
  ) => {
    if (localUserInfo) {
      setLocalUserInfo({
        ...localUserInfo,
        ...createBillingAddressUpdate(fieldName, e.target.value),
      });
    } else {
      setLocalUserInfo(
        createBillingAddressUpdate(
          fieldName,
          e.target.value,
        ) as BillingAddressDTO,
      );
    }
  };

  const handleCallingCode = (value: string) => {
    if (localUserInfo) {
      setLocalUserInfo({
        ...localUserInfo,
        callingCode: value,
      });
    }
  };

  return (
    <>
      <div className="flex justify-between">
        <div className="flex items-center gap-2">
          <UiH4 text={t("Billing address")} />
        </div>
        <button
          onClick={handleUpdate}
          type="button"
          className="font-noto-sans decoration-none w-[7.8125rem] rounded-[3.125rem] border border-[#232323] bg-black py-[0.9375rem] text-center text-base font-semibold leading-5 text-white opacity-100 focus:ring-gray-200"
        >
          {mutation.isLoading ? t("Saving") : t("Save")}
        </button>
      </div>
      <div className="rounded-[1.25rem] border border-[#DCDCDC] p-[1.25rem] pt-[1.3125rem]">
        <div className="items-top flex flex-col gap-[1.25rem]">
          <div className="flex flex-wrap items-center justify-between gap-[0.625rem] sm:flex-nowrap">
            <div className="w-full">
              <p className="mb-2 text-[1.00rem] font-normal tracking-[0.00rem] text-gray-900">
                <span className="text-gray-900">{t("Korean name")}</span>
              </p>

              <input
                onChange={(e) => handleChange(e, "koreanLastName")}
                value={localUserInfo?.koreanLastName || ""}
                className="bg-white-a700 w-full rounded-[0.625rem] border border-solid border-gray-300 p-3 text-gray-900 focus:outline-none sm:w-full"
                type="text"
                name="inputName"
              />
              {validationErrors.koreanLastName && (
                <div className="mt-2 text-[0.75rem] text-[#DA3838]">
                  {validationErrors.koreanLastName}
                </div>
              )}
            </div>
            {/* <div className="w-full">
              <p className="mb-2 text-[1.00rem] font-normal tracking-[0.00rem] text-gray-900 sm:w-[20.6875rem]">
                <span className="text-gray-900">{t("Korean First name")}</span>
              </p>

              <input
                onChange={(e) => handleChange(e, "koreanFirstName")}
                value={localUserInfo?.koreanFirstName || ""}
                className="bg-white-a700 w-full rounded-[0.625rem] border border-solid border-gray-300 p-3 text-gray-900 focus:outline-none"
                type="text"
                name="inputName"
              />
              {validationErrors.koreanFirstName && (
                <div className="mt-2 text-[0.75rem] text-[#DA3838]">
                  {validationErrors.koreanFirstName}
                </div>
              )}
            </div> */}
          </div>

          {/* lastname first name */}
          <div className="flex flex-wrap items-center justify-between gap-[0.625rem] sm:flex-nowrap">
            <div className="w-full">
              <p className="mb-2 text-[1.00rem] font-normal tracking-[0.00rem] text-gray-900">
                <span className="text-gray-900">{t("English last name")}</span>
              </p>

              <input
                onChange={(e) => handleChange(e, "lastName")}
                value={localUserInfo?.lastName || ""}
                className="bg-white-a700 w-full rounded-[0.625rem] border border-solid border-gray-300 p-3 text-gray-900 focus:outline-none sm:w-[20.6875rem]"
                type="text"
                name="inputName"
              />
              {validationErrors.lastName && (
                <div className="mt-2 text-[0.75rem] text-[#DA3838]">
                  {validationErrors.lastName}
                </div>
              )}
            </div>
            <div className="w-full">
              <p className="mb-2 text-[1.00rem] font-normal tracking-[0.00rem] text-gray-900 sm:w-[20.6875rem]">
                <span className="text-gray-900">{t("English first name")}</span>
              </p>

              <input
                onChange={(e) => handleChange(e, "firstName")}
                value={localUserInfo?.firstName || ""}
                className="bg-white-a700 w-full rounded-[0.625rem] border border-solid border-gray-300 p-3 text-gray-900 focus:outline-none"
                type="text"
                name="inputName"
              />
              {validationErrors.firstName && (
                <div className="mt-2 text-[0.75rem] text-[#DA3838]">
                  {validationErrors.firstName}
                </div>
              )}
            </div>
          </div>

          {/* email */}

          <div className="flex flex-wrap items-center justify-between gap-[0.625rem] sm:flex-nowrap">
            <div className="w-full">
              <p className="mb-2 text-[1.00rem] font-normal tracking-[0.00rem] text-gray-900">
                <span className="text-gray-900">{t("Email")}</span>
              </p>

              <input
                onChange={(e) => handleChange(e, "email")}
                value={localUserInfo?.email || ""}
                className="bg-white-a700 w-full rounded-[0.625rem] border border-solid border-gray-300 p-3 text-gray-900 focus:outline-none sm:w-[20.6875rem]"
                type="text"
                name="inputName"
              />
              {validationErrors.email && (
                <div className="mt-2 text-[0.75rem] text-[#DA3838]">
                  {validationErrors.email}
                </div>
              )}
            </div>
            <div className="w-full">
              <PhoneNumberSection
                varies={["MYPAGE/BILLING"]}
                callingCode={localUserInfo?.callingCode}
                phoneNumber={localUserInfo?.phoneNumber}
                onChangeCallingCode={handleCallingCode}
                onChangePhone={(value) => handleChange(value, "phoneNumber")}
                error={validationErrors.phoneNumber}
              />
            </div>
          </div>

          <div className="flex flex-col gap-[0.625rem]">
            <p className="text-[#232323]">{t("Address")}</p>
            <input
              onChange={(e) => handleChange(e, "address")}
              value={localUserInfo?.address || ""}
              type="text"
              className="h-[3.125rem] w-full rounded-[0.625rem] border border-gray-300 px-4 py-2 shadow-sm focus:border-[#DCDCDC] focus:outline-none"
            />
            {validationErrors.address && (
              <div className="mt-2 text-[0.75rem] text-[#DA3838]">
                {validationErrors.address}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BillingAddress;
